const scenes = [
  {
    id: 'restaurant',
    label: 'Restaurant',
    background: '/assets/bg-restaurant.png',
    npc: '/assets/npc-restaurant.png',
    animationKey: 'walk-in',
    sentences: [
      {
        prompt: "What would you like to eat?",
        template: "I would like [option], please.",
        options: [
          { label: "pizza",    emoji: "🍕" },
          { label: "a burger", emoji: "🍔" },
          { label: "noodles",  emoji: "🍜" },
        ],
      },
    ],
  },
  {
    id: 'zoo',
    label: 'Zoo',
    background: '/assets/bg-zoo.png',
    npc: '/assets/npc-zoo.png',
    animationKey: 'walk-in',
    sentences: [
      {
        prompt: "Which animal do you like?",
        template: "I like the [option]!",
        options: [
          { label: "elephant", emoji: "🐘" },
          { label: "giraffe",  emoji: "🦒" },
          { label: "penguin",  emoji: "🐧" },
        ],
      },
    ],
  },
  {
    id: 'bedroom',
    label: 'Bedroom',
    background: '/assets/bg-bedroom.png',
    npc: '/assets/npc-bedroom.png',
    animationKey: 'walk-in',
    sentences: [
      {
        prompt: "What do you want to do?",
        template: "I want to [option].",
        options: [
          { label: "read a book",    emoji: "📖" },
          { label: "play with toys", emoji: "🧸" },
          { label: "go to sleep",    emoji: "😴" },
        ],
      },
    ],
  },
  {
    id: 'school',
    label: 'School',
    background: '/assets/bg-school.png',
    npc: '/assets/npc-school.png',
    animationKey: 'walk-in',
    sentences: [
      {
        prompt: "What is your favourite subject?",
        template: "My favourite subject is [option].",
        options: [
          { label: "art",     emoji: "🎨" },
          { label: "maths",   emoji: "🔢" },
          { label: "reading", emoji: "📚" },
        ],
      },
    ],
  },
  {
    id: 'playground',
    label: 'Playground',
    background: '/assets/bg-playground.png',
    npc: '/assets/npc-playground.png',
    animationKey: 'walk-in',
    sentences: [
      {
        prompt: "What do you want to play?",
        template: "Let's play [option]!",
        options: [
          { label: "on the swings",  emoji: "🪁" },
          { label: "tag",            emoji: "🏃" },
          { label: "hide and seek",  emoji: "🙈" },
        ],
      },
    ],
  },
];

export default scenes;
